import React from 'react';
import {useField, useOperator} from '../../../../../data/hooks/categories';
import OperatorSelector from './OperatorSelector/OperatorSelector';
import OperatorValues from './OperatorValues/OperatorValues';
import FieldLabel from './FieldLabel/FieldLabel';
import {isOperatorSelectorVisible} from './OperatorSelector/isOperatorSelectorVisible';

function SubCondition(props) {
    const {category, subCondition, onRemoveSubCondition, onOperatorChange, onAddValue, onChangeValue} = props,
        field = useField(category.id, subCondition.field),
        operator = useOperator(category.id, field?.name, subCondition?.operator),
        operatorSelectorVisible = isOperatorSelectorVisible(field);

    return (
        <div className="row ORGroup mb-1">
            <div className="col-sm-4">
                <FieldLabel field={field} onRemoveSubCondition={onRemoveSubCondition} />
            </div>
            {operatorSelectorVisible ? (
                <div className="col-sm-3">
                    <OperatorSelector field={field} value={subCondition.operator} onChange={onOperatorChange} />
                </div>
            ) : null}
            <div className={operatorSelectorVisible ? 'col-sm-5' : 'col-sm-8'}>
                <OperatorValues field={field} operator={operator} values={subCondition.values} onChange={onChangeValue} onAdd={onAddValue} />
            </div>
        </div>
    );
}

export default SubCondition;
